import React from 'react';
import ResponseFormatter from './ResponseFormatter';
import { useTranslation } from '../../utils/LanguageContext';
import { VIEW_MODE } from '../QueryWorker.jsx';

const ResponseDisplay = ({ response }) => {
  if (!response) return null;
  const { t } = useTranslation();

  // Debug download (JSON)
  const handleDebugDownload = () => {
    try {
      const formatterElement = document.querySelector('.response-formatter');
      if (!formatterElement?.getMetadata) {
        throw new Error('Formatter not initialized');
      }
      
      const { timestamp, id } = formatterElement.getMetadata();
      const filename = `digital_horizon_course_advisor__response_${timestamp}_${id}.md`;
      
      const content = typeof response === 'string' ? response : JSON.stringify(response, null, 2);
      const blob = new Blob([content], { type: 'text/markdown' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading debug response:', error);
    }
  };

  // Customer download (plain text)
  const handleCustomerDownload = () => {
    try {
      const formatterElement = document.querySelector('.response-formatter');
      if (!formatterElement?.getPlainText || !formatterElement?.getMetadata) {
        throw new Error('Formatter not initialized');
      }

      const { timestamp, id } = formatterElement.getMetadata();
      const filename = `digital_horizon_recommendation_${timestamp}_${id}.txt`;
      
      const content = formatterElement.getPlainText();
      const blob = new Blob([content], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading customer response:', error);
    }
  };

  return (
    <div className="w-full max-w-4xl mx-auto">
      <ResponseFormatter data={response} />
     
      <div className="mt-4 flex space-x-4">
        {/* Customer download button */}
        <button
          onClick={handleCustomerDownload}
          className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors flex items-center"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
          {t('queryPage.downloadRecommendation')}
        </button>
        
        {/* Debug download button - only shown when VIEW_MODE is false */}
        {!VIEW_MODE && (
          <button
            onClick={handleDebugDownload}
            className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 transition-colors flex items-center"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1H3a1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.477.859h4z" clipRule="evenodd" />
            </svg>
            {t('queryPage.downloadSystem')}
          </button>
        )}
      </div>
    </div>
  );
};

export default ResponseDisplay;